// const api_link = './api/v1';

const api_link =  process.env.NODE_ENV === 'production'
     ? './api/v1'
     : 'https://projects.datanaut.eu/j10792/api/v1'

export default api_link